:root {
  --sellalong-heading-font: "Recoleta-Regular", serif;
  --sellalong-heading-font-size: 30px;
  --sellalong-heading-font-weight: normal;
  --sellalong-label-font: sans-serif;
  --sellalong-control-font: sans-serif;
  --sellalong-colour-primary: #52a69b;
  --sellalong-colour-primary-tint: #076358;
  --sellalong-colour-secondary: #014c43;
  --sellalong-colour-secondary-tint: #076358;
}
